import { Trans } from '@lingui/react'
import { arrayOf, shape, string } from 'prop-types'
import { compose } from 'redux'

import { isMarketplace } from 'shared/experiments/utils/featureFlags'
import defaultImage from 'shared/propsMocks/images/70x70.png'
import { getPlaceholderImage } from 'shared/utils/imageUtils'
import { withI18n } from 'shared/utils/withI18n'
import Button from 'views/components/atoms/Button'
import Image from 'views/components/atoms/Image'
import withMountPoints from 'views/enhancers/withMountPoints'
import { mountPointsType, publicRuntimeConfigType } from 'views/utils/propTypes'

import './OfferProduct.scss'

const OfferProduct = props => {
  const {
    flags,
    name: displayName,
    images,
    canonical_url: productUrl,
    upid: uPid,
    mountPoints,
    subtitle,
    publicRuntimeConfig: {
      publicConfig: { tenant },
      pageProperties: { experiments = [] },
    },
    staticImageUrl,
  } = props

  const isRx = Boolean(flags?.prescriptionMedicine)

  const productImg =
    images && images.length
      ? images[0]
      : [getPlaceholderImage(isRx, staticImageUrl)]

  const productImageProps = {
    src: productImg,
    alt: displayName,
    width: 70,
  }

  return (
    <div className="o-OfferProduct u-background-color--background l-content__row--fullWidth">
      <div className="l-flex u-padding l-content">
        <div className="l-flex__secondary">
          <Image
            {...productImageProps}
            className="o-OfferProduct__image"
            lazyLoad
            width={70}
            height={70}
          />
        </div>

        <div className="o-OfferProduct__displayName l-flex__primary u-padding--left@medium o-OfferProduct__truncate-with-ellipsis">
          <h5 className="u-no-margin u-padding-small u-hidden@medium">
            {displayName.length > 41
              ? `${displayName.slice(0, 41)}...`
              : displayName}
          </h5>
          <h2 className="u-no-margin o-OfferProduct__truncate-with-ellipsis">
            {displayName}
          </h2>
          <span className="u-hidden@small-tiny o-OfferProduct__truncate-with-ellipsis_subtitle">
            {subtitle}
          </span>
        </div>

        <div className="l-flex__primary u-padding--left l-flex l-flex--justify-content--end">
          <Button
            name="backToProduct"
            href={
              isMarketplace(experiments, tenant)
                ? mountPoints.getProductUrl(displayName, uPid)
                : productUrl
            }
            reverse
          >
            <span className="u-hidden@large">
              <Trans id="general.link.label.back" />
            </span>
            <span className="u-hidden@small-tiny u-hidden@medium u-visible@large">
              <Trans id="general.button.label.backProductLink" />
            </span>
          </Button>
        </div>
      </div>
    </div>
  )
}

OfferProduct.propTypes = {
  flags: shape({}),
  publicRuntimeConfig: shape(publicRuntimeConfigType),
  mountPoints: mountPointsType.isRequired,
  displayName: string,
  manufacturerNumber: string.isRequired,
  productUrl: string.isRequired,
  productImg: string,
  staticImageUrl: string.isRequired,
  subtitle: string,
  uPid: string,
  name: string,
  upid: string,
  images: arrayOf(string),
  canonical_url: string,
}

OfferProduct.defaultProps = {
  flags: {},
  publicRuntimeConfig: {},
  productImg: defaultImage,
  displayName: '',
  subtitle: '',
  uPid: null,
}

export default compose(withMountPoints, withI18n())(OfferProduct)
